exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*\r\n  Stylesheet for the selected potential project partners page.\r\n  @author Yannik Spengart, Andrea Villeda\r\n*/\n.no-link[data-v-60d0bf23] {\r\n    text-decoration: none !important;\n}", "", {"version":3,"sources":["/home/gitlab-runner/builds/b21bf5d0/0/mkz/werner-frontend/src/components/company/profile/partners/mypartners.css"],"names":[],"mappings":"AAAA;;;EAGE;AAEF;IACI,iCAAiC;CAClC","file":"mypartners.css","sourcesContent":["/*\r\n  Stylesheet for the selected potential project partners page.\r\n  @author Yannik Spengart, Andrea Villeda\r\n*/\r\n\r\n.no-link {\r\n    text-decoration: none !important;\r\n  }"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60d0bf23","scoped":true,"hasInlineConfig":false}!./src/components/company/profile/partners/mypartners.css
// module id = ilaw
// module chunks = 1